import { ReactElement } from 'react';
import { UPDATE_LAYOUT_SETTINGS } from '../ActionTypes';

type InitialStateType = {
  accountTitle?: string;
  accountBackUrl?: string;
  extra?: ReactElement;
};

export const INIT_STATE: InitialStateType = {
  accountTitle: '',
  accountBackUrl: '/'
};

export const LayoutSettingsReducer = (
  state = INIT_STATE,
  action: {
    type: string;
    payload: Partial<InitialStateType>;
  }
): InitialStateType => {
  switch (action.type) {
    case UPDATE_LAYOUT_SETTINGS:
      return {
        ...state,
        accountTitle: action.payload.accountTitle,
        accountBackUrl: action.payload.accountBackUrl,
        extra: action.payload.extra
      };
    default:
      return state;
  }
};
